<script>
    export let credits;

    $: totalReservedExtra = Object.values(credits.months).reduce((sum, month) => {
        return sum + month.reserved_extra;
    }, 0);
</script>

<div class="container">
    <span class="row-header">Monat</span>
    <div class="credits">
        <span class="row-header">Guthaben</span>
        {#if credits.extra.available - totalReservedExtra > 0}
            <span class="extra" title="Dein Extra-Guthaben gehört zu keinem Monat und verfällt daher nicht. Du kannst es frei ausgeben.">+{credits.extra.available - totalReservedExtra} Extra</span>
        {/if}
    </div>
</div>

<style>
    .container {
        position: sticky;
        top: 0;
        z-index: 5;
        background: linear-gradient(180deg, rgba(255, 255, 255, 1) 80%, rgba(255, 255, 255, 0.6));
        -webkit-backdrop-filter: blur(10px);
        backdrop-filter: blur(10px);
        border-bottom: 1px solid #ebe6e2;
        padding: 1rem 0;
        display: flex;
        justify-content: space-between;
        gap: 1rem;
        align-items: flex-start;
    }

    .row-header {
        font-weight: bold;
        font-size: 1.25rem;
    }

    .credits {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 0.125rem
    }

    .extra {
        font-size: 0.8rem;
        padding: 0.2rem 0.4rem;
        border-radius: 0.5rem;
        display: inline-block;
        background-color: rgb(180, 230, 170);
        color: rgb(0, 60, 3);
        cursor: help;
    }
</style>